// /**
//  * Order -CSV
//  */

// React
import React from 'react';

import {CSVLink} from 'react-csv';

// UI
import {Button} from '@material-ui/core';


// Icon
import Icon from '@mdi/react';
import {
  mdiArrowCollapseDown,
  mdiArrowDownBoldOutline,
  mdiTableArrowUp,
} from '@mdi/js';

type Props = {
  ordersDispatch: any;
  data: object[];
  filtersValues: any;
  loading: boolean;
};

function CSV(props: Props) {
  const handleCreateCSV = () => {
    props.ordersDispatch({...props.filtersValues, size: 10000});
  };
  const flattData = (data: any) => {
    const newData = data.map(el => {
      return {
        parcelItemId: el.id,
        productName: el.productName,
        productCode: el.productCode,
        variantId: el.skuId,
        variantCode: el.variantCode,
        count: el.count,
      };
    });
    return newData;
  };

  return (
    <>
      {props.data?.length > 0 ? (
        <CSVLink
          data={flattData(props.data)}
          filename="parcelVariants.csv"
          style={{
            textDecoration: 'none',
          }}
        >
          <Button
            color="primary"
            variant="outlined"
            size="large"
            startIcon={<Icon path={mdiArrowDownBoldOutline} size={'16px'} />}
            style={{
              textDecoration: 'none',
            }}
            data-cy="excel"
          >
            EXCEL
          </Button>
        </CSVLink>
      ) : (
        <Button
          size="large"
          style={{marginLeft: '5px'}}
          variant="contained"
          color="primary"
          startIcon={<Icon path={mdiArrowDownBoldOutline} size={'16px'} />}
          onClick={handleCreateCSV}
          disabled={props.loading}
          data-cy="csv"
        >
          ایجاد فایل CSV
        </Button>
      )}
    </>
  );
}

export default CSV;
